import { BulkCheckbox, ConvertedCurrencyValue, FlexSpaceBetween, SpacedLongDash } from '@mews-commander/ui';
import { Typography, Stack } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { DateTime } from '@mews/framework';
import { TotalAmountAndCount } from '../../../../types';
import { YearMonthLabel } from './YearMonthLabel';

interface ProductOrderLabelProps {
    total: TotalAmountAndCount;
    someSelected: boolean;
    allSelected: boolean;
    toggleSelect(): void;
    dateTime: DateTime;
}

export const MonthListLabel: React.FC<ProductOrderLabelProps> = ({
    dateTime,
    total,
    someSelected,
    allSelected,
    toggleSelect,
}) => (
    <FlexSpaceBetween>
        <Stack itemAlignment="center" spacing="50">
            <BulkCheckbox allSelected={allSelected} someSelected={someSelected} onChange={toggleSelect} />
            <YearMonthLabel dateTime={dateTime} />
            <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                {SpacedLongDash}
                {total.unitCount}
                {UnicodeEntity.MultiplicationSign}
            </Typography>
        </Stack>
        <div>
            <ConvertedCurrencyValue amount={total.amount} />
        </div>
    </FlexSpaceBetween>
);
